import { DocumentData } from "firebase/firestore";

export const isApplicationEditable = (
  application: DocumentData | undefined,
  asDealer = false
) => {
  if (!application) {
    return false;
  }
  if (asDealer && application["lock_dealer"]) {
    return false;
  }
  if (application["status"] === "active") {
    return true;
  }
  if (!asDealer && application["status"] === "rejected") {
    //todo: should we allow everything to be editable still?
    return true;
  }
  return false;
};
